import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import logo from "../../assets/images/logo.png";
import { AnimatePresence, motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../../services/ApiService.js";
import { toast } from "react-toastify";
import AuthGuard from "../../components/AuthGuard.jsx";
import { useTranslation } from "react-i18next";

const VerifyOTP = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isLoader, setIsLoader] = useState(false);
  const inputsRef = useRef([]);
  const navigate = useNavigate();
    const { t, i18n } = useTranslation();
          const isRTL = i18n.language === 'ar';
  const [resendTimer, setResendTimer] = useState(0);

  const company_id = localStorage.getItem("company_id");
  console.log(company_id);

  const deviceToken = localStorage.getItem("deviceToken");

  const phone = localStorage.getItem("phone");
  console.log(phone);

  useEffect(() => {
    if (!resendTimer) return;
    const id = setInterval(() => setResendTimer((t) => t - 1), 1000);
    return () => clearInterval(id);
  }, [resendTimer]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!company_id) {
      toast.error("Missing registration data. Please register again.");
      navigate("/");
    }
    if (!company_id) {
      toast.error("No user ID found – please sign‑up again.");
    }
  }, [company_id, navigate]);

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (value === "") {
      // Allow deletion
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
      return;
    }

    if (/^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < 5 && inputsRef.current[index + 1]) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputsRef.current[index - 1].focus();
    } else if (e.key === "ArrowLeft" && index > 0) {
      inputsRef.current[index - 1].focus();
    } else if (e.key === "ArrowRight" && index < otp.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };
const clearTalentData = () => {
  const talentData = localStorage.getItem("user");
  if (talentData) {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    console.log("Previous talent session cleared");
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    const otpCode = otp.join("");
    if (otpCode.length !== 6) {
      toast.error("Please enter the 6‑digit OTP");
      setIsLoader(false);
      return;
    }

    try {
      clearTalentData()
      const formData = new FormData();
      formData.append("otp", otpCode);
      formData.append("company_id", company_id);
      if (deviceToken) formData.append("deviceToken", deviceToken);

      const res = await ApiService.request({
        method: "POST",
        url: "company/verifyOTP",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });

      const { status, message, data } = res.data;
      if (status) {
        toast.success(message);
        const company = { ...data.company, auth_token: data.auth_token };
        localStorage.setItem("company", JSON.stringify(company));
        navigate("/company/dashboard");
        // let user = data.data.company;
        // user.auth_token = data.data.auth_token;
        // localStorage.setItem("company", JSON.stringify(data.data.company));
      } else {
        toast.error(message);
      }
    } catch (err) {
      console.error("OTP verification failed:", err);
      toast.error("OTP verification failed. Please try again.");
    } finally {
      setIsLoader(false);
    }
  };

  const handleResendOTP = async () => {
    if (resendTimer > 0) return;
    if (!company_id) {
      toast.error("Missing company ID. Please register again.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("company_id", company_id);
      if (deviceToken) formData.append("deviceToken", deviceToken);

      const res = await ApiService.request({
        method: "POST",
        url: "company/resendOTP",
        data: { company_id, phone },
        headers: { "Content-Type": "multipart/form-data" },
      });

      const { status, message } = res.data;
      if (status) {
        toast.success(message || "OTP has been resent successfully.");
        setResendTimer(60);
      } else {
        toast.error(message || "Failed to resend OTP.");
      }
    } catch (err) {
      console.error("Resend OTP failed:", err);
      toast.error("Failed to resend OTP. Please try again.");
    }
  };

  return (
<AuthGuard>
  <AnimatePresence mode="wait">
    <motion.div
      key="main"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
      className="inter-font main-bg min-vh-100 d-flex flex-column justify-content-center align-items-center"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <Container className="inter-font position-absolute top-0 mt-3" style={{ [isRTL ? 'left' : 'right']: '20px' }}>
        <Row className="inter-font align-items-start">
          <Link to={"/"} xs={12} className="inter-font text-center text-md-start mb-2 mb-md-0 cursor-pointer">
            <img src={logo} alt="Logo" style={{ height: "50px" }} />
          </Link>
        </Row>
      </Container>

      <div
        className="inter-font container upload-doc-coontainer bg-white p-4 d-flex flex-column justify-content-center align-items-center rounded-4"
        style={{ width: "90%", maxWidth: "700px" }}
      >
        <h2 className="inter-font fw-bold inter-font mt-4 fs-4 fs-md-3">{t('c_reg_s4_title')}</h2>
        <p
          className="inter-font inter-font text-center"
          style={{ color: "rgba(0, 0, 0, 0.3)" }}
        >
          {t('c_reg_s4_dec')}
        </p>

        <Form onSubmit={handleSubmit}>
          <div className="inter-font d-flex flex-column align-items-center">
            <div
              className="inter-font d-flex flex-wrap justify-content-center gap-2 gap-md-2 mb-3"
              style={{ maxWidth: "100%", rowGap: "10px" }}
            >
              {[...Array(6)].map((_, i) => (
                <Form.Control
                  key={i}
                  type="text"
                  maxLength="1"
                  className="inter-font text-center fs-4 my-1 otp-input"
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#f5f5f5",
                    border: "none",
                    boxShadow: "inset 0 0 0 1px #ccc",
                    borderRadius: "5px",
                  }}
                  onChange={(e) => handleChange(e, i)}
                  onKeyDown={(e) => handleKeyDown(e, i)}
                  ref={(el) => (inputsRef.current[i] = el)}
                  value={otp[i]}
                />
              ))}
            </div>

            <p className="inter-font mb-0 text-center">
              {t('c_reg_s4_text')}
              <span
                className={isRTL ? "me-2" : "ms-2"}
                style={{
                  color: resendTimer ? "gray" : "#5e4b00",
                  fontWeight: 500,
                  cursor: resendTimer ? "not-allowed" : "pointer",
                  textDecoration: "underline",
                  textDecorationColor: resendTimer ? "gray" : "#5e4b00",
                }}
                onClick={resendTimer ? undefined : handleResendOTP}
              >
                {resendTimer > 0 ? `${t('resend_in')} ${resendTimer}s` : t('c_reg_s4_resend')}
              </span>
            </p>

            <Button
              type="submit"
              className="btn btn-base mt-4 border-0"
              style={{
                width: "100%",
                maxWidth: "200px",
                height: "55px",
              }}
              disabled={isLoader}
            >
              {isLoader ? t('sending') : t('c_reg_s4_resend')}
            </Button>
          </div>
        </Form>
      </div>
    </motion.div>
  </AnimatePresence>
</AuthGuard>
  );
};

export default VerifyOTP;
